import React from 'react';
import useTranslate from '../../../../customHooks/useTranslate';
import Icon from '../../../../muiComponents/Icon';

interface QuickAccessButtonProps {
    label: string;
    icon: string;
    color?: string;
    onClick: () => void;
}

const QuickAccessButton: React.FC<QuickAccessButtonProps> = ({
    label,
    icon,
    color,
    onClick,
}) => {
    const translate = useTranslate();
    return (
        <button onClick={onClick} className='quick-access-button'>
            <div
                className={`quick-access-button__icon ${
                    color ? `--${color}` : ''
                }`}
            >
                <Icon iconName={icon} />
            </div>
            {translate(label)}
        </button>
    );
};

export default QuickAccessButton;
